import { Directive, ElementRef, HostListener, Inject, Input, LOCALE_ID } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[currencyFormatDir]'
})
export class CurrencyFormatDirective {
  @Input('currencyFormatDir') currencyCode: string = 'USD'; // Default currency

  
  regexStr = '^\$(([1-9]\d{0,2}(,\d{3})*)|0)?(\.\d{2})?$';
  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private el: ElementRef,
    private ngControl: NgControl
  ) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value;

    // Allow navigation keys, backspace, delete, etc.
    if (['ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Tab'].includes(event.key)) {
      return;
    }

    // Prevent non-numeric and non-decimal characters
    if (!/^\d$/.test(event.key) && event.key !== '.') {
      event.preventDefault();
    }

    // Handle decimal point
    if (event.key === '.' && value.includes('.')) {
      event.preventDefault(); // Only one decimal allowed
    }
    
  }

  @HostListener('focus', ['$event.target'])
  onFocus(target: any) {
    // On focus, remove currency formatting to allow raw input
    var formattedValue = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(this.convertToNumber(target.value))
    this.ngControl.control?.setValue(formattedValue);
    this.el.nativeElement.value = formattedValue;
  }

  @HostListener('blur', ['$event.target']) onBlur(target: any) {
    // On blur, apply currency formatting
    var formattedValue = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(this.convertToNumber(target.value))
    this.ngControl.control?.setValue(formattedValue);
    this.el.nativeElement.value = formattedValue;
  }

  private convertToNumber(value: string): number | null {
    value = value.replace('$','');
    value = value.replace(',','');
    if (!value && typeof value === 'number') {
      return null;
    }
    // Remove non-numeric characters except the decimal point
    return Number(value);
  }
}